
jQuery(function($) {
  	

	/******************************************/
		/********** VAR-----------/
	/******************************************/
	var LARGEUR_MAX_MOBILE = 800;
	var header = $("#masthead");


    $('.to_nicedropdown-js').niceSelect();
    

     //  WOW EFFECT //
    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null // optional scroll container selector, otherwise use window
      }
    );
   wow.init();


   // SLIDER PAGE CLIENT //



   
    //  ///////////  //
  //  JS : GALERIE D'IMAGE  //
  //  ///////////  //
  $("#lightgallery").lightGallery({
       subHtmlSelectorRelative: true
  }); 



  $(".wysiwyg .gallery").lightGallery({
      selector:'a',
      subHtmlSelectorRelative: true
  }); 




  // AJUSTEMENT AU SCROLL + RESIZE BLOCK DE DROITE : CONTACT
    var espace_menu_haut = $("#masthead").height()+10;
   var $menu_right = $('.BtnContactAllPage');
  $(window).resize(function() {
     ajustement_menu_right();
  });

 $(window).scroll(function(){
      ajustement_menu_right();
  });

 function ajustement_menu_right(){
   
   var scrol_actuel =  $(window).scrollTop();
   var browserHeight = Math.round($(window).height()-espace_menu_haut);
   // on fait venir le bouton shop online //
   $menu_right.stop().animate({
    top: Math.round(scrol_actuel+browserHeight/2 - 100),
    }, 150);

   }  

    ajustement_menu_right();


  // TABS ///
    // http://www.entheosweb.com/tutorials/css/tabs.asp
    $(".js-Tabs-Inner-Content").hide();
    $(".js-Tabs-Inner-Content:first").show();

  /* if in tab mode */
    $(".Tabs-Liste li").click(function() {

      var activeTab = $(this).attr("rel");

       if($(this).hasClass('active')){
        $("#"+activeTab).slideUp(400); 
        $(this).removeClass('active');
        $('.Tabs-Liste').removeClass('one-item-active');
         $('.SectionEquipe .Tabs-Liste').removeClass('one-item-active');
         $('.SectionEquipe .TeamListItem-Button .icon-to-change').removeClass('icon-moins').addClass('icon-plus');

      }else{

         $('.SectionEquipe .Tabs-Liste').addClass('one-item-active');
         $('.SectionEquipe .TeamListItem-Button .icon-to-change').removeClass('icon-plus').addClass('icon-moins');

        $(".js-Tabs-Inner-Content").hide();
        $("#"+activeTab).fadeIn();    
      
        $(".Tabs-Liste li").removeClass("active");
        $(this).addClass("active");

      $(".js-Tabs-Inner-Title").removeClass("d_active");
      $(".js-Tabs-Inner-Title[rel^='"+activeTab+"']").addClass("d_active");

      }
    
    });
  /* if in drawer mode */
  $(".js-Tabs-Inner-Title").click(function() {
      
      if($(this).next().css('display') == 'none'){
          $(".js-Tabs-Inner-Content").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).fadeIn();
        
        $(".js-Tabs-Inner-Title").removeClass("d_active");
          $(this).addClass("d_active");
        
        $(".Tabs-Liste li").removeClass("active");
        $(".Tabs-Liste li[rel^='"+d_activeTab+"']").addClass("active");
    }else{
      $(this).next().slideUp(400);
      $(".js-Tabs-Inner-Title, .Tabs-Liste li").removeClass("d_active");
    }
    });

  
  /* Extra class "tab_last" 
     to add border to right side
     of last tab */
  $('.Tabs-Liste li').last().addClass("tab_last");
  $('.Tabs-Liste li').first().addClass("active");

  // GET HASH ? 
   // SI #tab1, #tab2, #tab3.. alors on clique sur le li pour activer le bon js-Tabs-Inner-Content //
   if(window.location.hash) {
    var $hash_location = window.location.hash;
    if($hash_location == '#tab1' || $hash_location == '#tab2' || $hash_location == '#tab3' || $hash_location == '#tab4')
    {
      $hash_location = $hash_location.substring(1);
      $( ".Tabs-Liste li[rel='"+$hash_location+"']").trigger( "click" );
    }
  } 
  // FIN TABS 



  // Extra pour TABS EQUIPE 
  $(".SectionEquipe .js-Tabs-Inner-Content:first").hide();
  $('.SectionEquipe .Tabs-Liste li').first().removeClass("active");
 $(".SectionEquipe .Tabs-Liste .Tabs-Liste-Item").click(function() {

   


   

 });

  
   /*************/
    /* OUVERTURE / FERMETURE DU MENU EXPERIENCE */
    /*************/
    $('.menu-experience-js').next().hide();
    $('.menu-experience-js').click(function(e){
        if($(this).attr('aria-expanded') == 'false'){
           $(this).find('.Buton-Title').text('Fermer l\'encart expérience');
           $(this).attr('aria-expanded', "true");
           $(this).next().slideDown(500);
           $(this).find('.Buton-Icon').html('<i class="icon-moins"></i>');
         }else{
            $(this).find('.Buton-Title').text('L\'expérience de Steve ODEZENNE');
            $(this).attr('aria-expanded', "false");
            $(this).next().slideUp(500);
            $(this).find('.Buton-Icon').html('<i class="icon-plus"></i>');
         }
         e.preventDefault();
    });



 /* **************************************************  */
  /* SLIDER ONLY MOBILE */
  /* **************************************************  */

  $slick_slider = $('.PostResume-SlideModile, .FormationResume-SlideMobile');
  settings_slider = {
  slidesToShow: 2,
  slidesToScroll: 2,
  arrows:true,
  dots: false,
  responsive: [
    {
      breakpoint: 550,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
          arrows:true,
		  dots: false,
      }
    }
  ]
    // more settings
  };

  slick_on_mobile( $slick_slider, settings_slider);

// slick on mobile
  function slick_on_mobile(slider, settings){
    $(window).on('load resize', function() {
      if ($(window).width() > 767) {
        if (slider.hasClass('slick-initialized')) {
          slider.slick('unslick');
        }
        return;
      }
      if (!slider.hasClass('slick-initialized')) {
        return slider.slick(settings);
      }
    });
  }


  //
  // SLIDER -> Partie Client
  //

   $('.SectionClient-Slide--js').slick({
        //setting-name: setting-value
        dots: true,
        arrows:false,
        draggable:false,
        autoplay: true,
        autoplaySpeed: 2000,
        speed:1400,
        //fade: true,
        pauseOnHover:false,
        pauseOnFocus:false,
     //   infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 2,
               dots: true,
              arrows:false,
               autoplaySpeed: 2000,
            }
          }
        ]
   });





	/******************************************/
		/********** SCROLL - NAV -----------/
	/******************************************/
 $(window).scroll(function () {
    if($('body').hasClass('home')){
      action_on_scroll();
    }
  });

  var path_top_right_orange =  SVG.find('path.PATHTEST');
  var path_to_animate, this_id;

 //  var draw = SVG('#svg_test_top');
 //  var gradient = draw.gradient('linear', function(add) {
	//   add.stop(0, '#fff');
	//   add.stop(1, '#333');
	// });

  // path_top_right_orange.fill(gradient);


  function action_on_scroll(){
    var l_window = parseInt($(window).width());
    h_header = header.height();

    if (l_window > LARGEUR_MAX_MOBILE){
       if ($(window).scrollTop() > 30){
        header.addClass("Masthead--sticky");
        $("body").addClass('header--sticky');
       
       // gradient.animate({duration: 600, delay:0,when: 'now',swing: false, times: 1, wait: 0}).from(0, 0).to(0, 1);
  //       gradient.animate({duration: 600, delay:0,when: 'now',swing: false, times: 1, wait: 0}).update(function(add) {
		//   add.stop(0, '#333', 0.2);
		//   add.stop(1, 'red', 1);
		// });

        path_top_right_orange.animate({duration: 500, delay:0,when: 'now',swing: false, times: 1, wait: 0}).plot('M0,0v-36c212.652,13.63,638,3.5,747.5,3c115.509,1.229,454-86.191,652-86c174-0.191,432.366,70.336,498.48,77.395L1899.736,0H0z');
        }else{
              header.removeClass("Masthead--sticky");
            $("body").removeClass('header--sticky');
            path_top_right_orange.animate({duration: 500, delay:0,when: 'now',swing: false, times: 1, wait: 0}).plot('M0,0v313.005c230.774,59.229,472.609,52.674,725.504-19.663c379.342-108.507,622.311-133.406,970.753-108.507c69.715,4.981,137.629,11.001,203.743,18.06L1899.736,0H0z');
        }
    }else{

	      if ($(window).scrollTop() > 0){
	        header.addClass("fixed_scrol_mobile");
	        $("body").addClass('header--sticky');
	            }else{
	              header.removeClass("fixed_scrol_mobile");
	              $("body").removeClass('header--sticky');
	            }
	    }
	 }

	 
	 /* HOVER SUR LES RESUMES DES POSTS */

	 $( "a.PostResume, a.FormationResume" ).hover(
	  function() {
	  	 this_id = $(this).attr('id');
	  	  path_to_animate =  SVG.find('path.SVG_'+this_id);
	  	  path_to_animate.animate({duration: 300, delay:0,when: 'now',swing: false, times: 1, wait: 0}).plot('M0,62.486l377.53,0.002c0-8.176,0-10.175,0-27.342C241.864,31.244,250,9.486,168,0.486C96.667-3.514,40.667,17.152,0,62.486z');
	   
	  }, function() {
	   	  path_to_animate.animate({duration: 600, delay:0,when: 'now',swing: false, times: 1, wait: 0}).plot('M0,62.486l377.53,0.002c0-8.176-2,25.382-2,8.216c-34.5,7.402-84.469,7.081-126,7.359C232.267,78.178,34.53,67.563,0,62.486z');
	  }
	); 





  // FORM CONTACT LABEL ///
    $( ".wpcf7-form label.to_move" ).click(function() {
      $( this ).parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea" ).focus(function() {
      $( this ).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });

 


 });